import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    terminations: [],
    terminations_loading: false,
    total_terminations: 0,
    total_devices_marked_for_termination: 0,
    week_total: 0

  };
};

const state = getDefaultState();

const getters = {
  getTerminations: state => {
    return state.terminations;
  },
  getTerminationsLoading: state => {
    return state.terminations_loading;
  },
  getTerminationsTotal: state => {
    return state.total_devices_marked_for_termination;
  },
  getWeekTotal: state => {
    return state.week_total;
  }
};

const actions = {
  fetchTerminations({ commit, rootGetters }, payload) {
    const offset = payload.offset ?? 0;
    commit("setTerminationsLoading", true);
    const query = `
      query PaginatedTerminations($pagination: PaginationInput) {
        paginated_terminations(pagination: $pagination) {
          terminations{
            id
            status
            return_process
            terminate_at
            created_at
            device {
              id
              imei
              has_pending_services
            }
            notes
            removal_installation_id
            can_process
            customer {
              id
              company_name
              no_devices
              payments_up_to_date
            }
            order {
              id
              invoices{
                id 
                paid_at
              }
            }
          }
          current_page
          per_page
          sort_direction
          ${offset == 0 ? 'total_pending' : '' }
          ${offset == 0 ? 'current_week' : '' }
        }
      }
    `;

    const variables = {
      pagination: {
        limit: payload.limit,
        offset: offset,
        order_direction: payload.order_direction ?? 'asc',
        sort_by: payload.order_by ?? 'created_at',
        status: payload.status ?? 'pending',
        from_date: payload.from_date,
        to_date: payload.to_date,
        search: payload.search
      }
    };
    axios.post(rootGetters.getGraphQlUrl, { query, variables }, rootGetters.getDefConf)
      .then(res => {
        if (res.data.errors !== undefined && res.data.errors.length > 0) {
          alert(res.data.errors[0].message);
          console.log(res);
        } else {
          commit(
            "setTerminations",
            res.data.data.paginated_terminations.terminations.map(termination => {
              return {
                id: termination.id,
                status: termination.status,
                device_id: termination.device.id,
                imei: termination.device.imei,
                terminate_at: termination.terminate_at,
                return_process: termination.return_process,
                created_at: termination.created_at,
                customer_id: termination.customer.id,
                customer: termination.customer.company_name,
                payments_up_to_date: termination.customer.payments_up_to_date,
                order: termination.order,
                invoices: termination.order ? termination.order.invoices : [],
                last_device: termination.customer.no_devices === 1,
                has_not_paid_invoices: termination.customer.payments_up_to_date === false,
                has_pending_services: termination.device.has_pending_services,
                removal_installation_id: termination.removal_installation_id,
                notes: termination.notes,
                can_process: termination.can_process

              };
            })
          );
          if( res.data.data.paginated_terminations.total_pending !== undefined ){
            commit("setTotalTerminations", res.data.data.paginated_terminations.total_pending);
          }
          if( res.data.data.paginated_terminations.current_week !== undefined ){
            commit("setWeekTotal", res.data.data.paginated_terminations.current_week);
          }
        }
      })
      .catch(err => {
        alert(err);
        console.error(err);
      })
      .finally(() => {
        commit("setTerminationsLoading", false);
      });
  }
};

const mutations = {
  setTerminations(state, value) {
    state.terminations = value;
  },
  setTerminationsLoading(state, value) {
    state.terminations_loading = value;
  },
  setTotalTerminations(state, value) {
    state.total_devices_marked_for_termination = value;
  },
  
  setWeekTotal(state, value) {
    state.week_total = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};